import { Component } from "react";
import BCService from "../../../services/BC";
import SalesService from "../../../services/SellingService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
class PayementTotalBillEspece extends Component {
  state = {
    amount: "",
    selectedFile: null,
    urlFile: "",
    fileName: "Ticket de caisse",
  };

  constructor(props) {
    super(props);
    this.state = {
      amount: this.props.restToPay,
      fileName: "Ticket de caisse",
      selectedFile: null,
      urlFile: "",
    };
    this.changeAmount = this.changeAmount.bind(this);
    this.onFileChangeHandler = this.onFileChangeHandler.bind(this);
  }

  changeAmount(event) {
    // var amount = event.target.value;
    if (event.target.value > this.state.amountMax) {
      this.setState({ alert_message: "error" });
    } else {
      this.setState({ amount: event.target.value });
    }

    // console.log("amount", this.state.amount);
  }

  refreshPage() {
    window.location.reload(false);
  }

  onFileChangeHandler = (event) => {
    if (event.target.files[0].size > 2097152) {
      toast.info("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      this.setState({
        fileName: event.target.files[0].name,
      });
      this.setState({
        selectedFile: event.target.files[0],
        loaded: 0,
      });
    }
  };

  payerBill = (e) => {
    const url = window.location.pathname.split("/")[1];
console.log("url",url)
    if (url === "payerBill") {
      if (this.state.amount === "") {
        toast.error("Erreur : le champ montant  est vide");
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),
          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),
          isAvanceOrTotalPayement: 1,
          typePayement: 0,
          ammountPayed: this.props.restToPay,
          urlFile: "any",
          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        };

        BCService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              this.refreshPage();
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            this.refreshPage();
          });
      }
    } else {
      if (this.state.amount === "") {
        toast.error("Erreur : le champ montant  est vide");
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),
          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),
          isAvanceOrTotalPayement: 1,
          typePayement: 0,
          ammountPayed: this.props.restToPay,
          urlFile: "any",
          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        };

        SalesService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              this.refreshPage();
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            this.refreshPage();
          });
      }
    }
  };

  render() {
    return (
      <div className="box-body">
        <br />
        <br />
        <label>Charger la ticket de caisse </label>
        <br />
        <ToastContainer />

        <div class="row">
          <div class="col-md-12">
            <div className="form-group files color">
              <div class="row">
                <div class="col-md-3">
                  <label>Montant : </label>
                  <input
                    disabled
                    class="form-control"
                    name="amount"
                    value={this.props.restToPay}
                    //  onChange={this.changeAmount}
                  />
                </div>
                <div class="col-md-9">
                  <label>Caisse</label>
                  <ListBanquesToPayement type={2} />
                  {/* <div className="form-group">
                    {" "}
                    <label for="exampleInputFile">Le fichier </label>
                    <div class="custom-file">
                      <input
                        type="file"
                        accept="application/pdf,.jpg, .jpeg, .png"
                        className="custom-file-input"
                        name="file"
                        id="exampleInputFile"
                        onChange={this.onFileChangeHandler}
                      />
                      <label class="custom-file-label" for="exampleInputFile">
                        {this.state.fileName}
                      </label>
                    </div>
                  </div> */}
                  {/* <div class="input-group">
                    <div class="custom-file">
                      <input
                        accept="application/pdf, .jpg, .jpeg, .png"
                        type="file"
                        className="custom-file-input"
                        id="exampleInputFile"
                        onChange={this.onFileChangeHandler}
                      />
                      <label class="custom-file-label" for="exampleInputFile">
                        Ticket de caisse
                      </label>
                    </div>
                  </div> */}
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button
            type="submit"
            onClick={this.payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
    );
  }
}
export default PayementTotalBillEspece;
